import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  makeStyles,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
} from "@material-ui/core/";
import FormHeader from "../FormHeader";
import config from "../../app/config";
import localizedStrings from "../../utils/localize";

const useStyle = makeStyles((theme) => ({
  tableStyle: {
    width: "90%",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}));

function FormUpload(props) {
  const classes = useStyle(props);
  //current lagnguage
  const language = useSelector((state) => state.language.language);
  //set the current language to localize string
  localizedStrings.setLanguage(language);
  useEffect(() => {
    localizedStrings.setLanguage(language);
  }, [language]);

  const findLatestFileUrl = (uploadedFiles, documentType) => {
    let latestFile = null;
    uploadedFiles.forEach((data) => {
      if (data.name.includes(documentType)) {
        if (!latestFile || data.created > latestFile.created) {
          latestFile = data;
        }
      }
    });

    return latestFile ? latestFile : null;
  };

  let mapFileUploadFields = "";
  // if (props.formDetails.length > 0) {
  //   let uploadedfilesData = props.uploadedFile;
  //   let updatedFiles = [...uploadedfilesData].sort(
  //     (a, b) => new Date(a.created) - new Date(b.created),
  //   );
  //   mapFileUploadFields = props.formDetails.map((element, index) => {
  //     return (
  //       <TableRow key={index}>
  //         <TableCell component="th" scope="row">
  //           {
  //             localizedStrings.application.document.types[
  //               element.ses_documenttype
  //             ]
  //           }
  //         </TableCell>

  //         <TableCell>
  //           <TextField
  //             margin="normal"
  //             id="Upload File"
  //             label="Choose File"
  //             type="file"
  //             autoComplete="Choose File"
  //             name={element.ses_documenttype}
  //             onChange={props.fileHandle}
  //           />
  //         </TableCell>
  //         <TableCell style={{ marginLeft: "1rem" }}>
  //           {props.uploadedFile.length > 0 ? (
  //             props.uploadedFile.find((data) =>
  //               data.name.includes(element.ses_documenttype),
  //             ) !== undefined ? (
  //               <Button
  //                 variant="outlined"
  //                 color="primary"
  //                 style={{ textTransform: "none", textDecoration: "none" }}
  //               >
  //                 <a
  //                   href={`${config.SHAREPOINTSITEURL}${
  //                     findLatestFileUrl(updatedFiles, element.ses_documenttype)
  //                       .url
  //                   }`}
  //                   download={`${config.SHAREPOINTSITEURL}${
  //                     findLatestFileUrl(updatedFiles, element.ses_documenttype)
  //                       .url
  //                   }`}
  //                   rel="noopener noreferrer"
  //                 >
  //                   {
  //                     findLatestFileUrl(
  //                       updatedFiles,
  //                       element.ses_documenttype,
  //                     ).name.split("-")[1]
  //                   }
  //                 </a>
  //               </Button>
  //             ) : (
  //               ""
  //             )
  //           ) : (
  //             ""
  //           )}
  //         </TableCell>
  //       </TableRow>
  //     );
  //   });
  // }

  return (
    <Grid container item className={classes.tableStyle}>
      <FormHeader name={localizedStrings.application.document.heading} />
      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 700 }}>
                {localizedStrings.application.document.title1}
              </TableCell>
              <TableCell></TableCell>
              <TableCell style={{ fontWeight: 700 }}>
                {localizedStrings.application.document.title2}
              </TableCell>
            </TableRow>
          </TableHead>
          <br />
          <TableBody style={{ margin: "1rem" }}>
            {mapFileUploadFields.length > 0
              ? mapFileUploadFields
              : "Loading..."}
            <br />
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
}

export default FormUpload;
